/** * 首页 */
<template>
  <h5>保e投PC端出单平台</h5>
</template>
<script>
export default {};
</script>

<style>
h5 {
  font-size: 28px;
  text-align: center;
  line-height: 600px;
}
</style>



// WEBPACK FOOTER //
// src/views/home.vue